// ============================================
// Patreon Gate — build-time token verification
//
// Build script (build_web.py) writes a signed token into localStorage
// under a non-obvious key. This module verifies the token against a
// nonce embedded in a <meta> tag at build time.
//
// Setting localStorage['is_patreon'] = 'true' no longer works.
// ============================================

const _S = [112,110,111,95,103,97,116,101]; // salt bytes
function _salt() { return _S.map(c => String.fromCharCode(c ^ 0x17)).join(''); }

function _fnv(str) {
    let h = 0x811c9dc5;
    for (let i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h = Math.imul(h, 0x01000193);
    }
    return (h >>> 0).toString(36);
}

let _cache = null;

export function isPat() {
    if (_cache !== null) return _cache;
    try {
        const tok = localStorage.getItem('_pno_c');
        if (!tok) { _cache = false; return false; }
        const nonce = document.querySelector('meta[name="pno-b"]')?.content;
        if (!nonce) { _cache = false; return false; }
        _cache = tok === _fnv(_salt() + nonce);
        return _cache;
    } catch(e) {
        _cache = false;
        return false;
    }
}

// Force re-evaluation (for test harness)
export function _resetPat() { _cache = null; }
